export const dot = (input) => {
  if (input === '0/0') {
    return './.';
  }
  return input && input !== '0' ? input : '.';
};